import type { BackToSchool2026SaleVariant } from '~/features/promotions/constants/back-to-school-2026-sale';
import {
  getBts2026SaleSlideKey,
  getBts2026SaleVariant,
  resolveBts2026SaleVariant,
} from '~/features/promotions/utils/get-back-to-school-2026-sale-variant';

import type { PromoCampaignSurfaceRenderers } from '../types';

export const BACK_TO_SCHOOL_2026_CAMPAIGN_ID = 'back-to-school-2026';

export const backToSchool2026CampaignCore: Pick<
  PromoCampaignSurfaceRenderers<BackToSchool2026SaleVariant>,
  'id' | 'getSlideKey' | 'matches' | 'isGateReady' | 'replacesEvergreenKeys' | 'resolve'
> = {
  id: BACK_TO_SCHOOL_2026_CAMPAIGN_ID,
  getSlideKey: ({ resolved }) => getBts2026SaleSlideKey(resolved),
  matches: ({ forcedPromotionId, promotionId }) =>
    getBts2026SaleVariant(forcedPromotionId) != null || getBts2026SaleVariant(promotionId) != null,
  isGateReady: ({ forcedPromotionId, promotionFetched }) =>
    getBts2026SaleVariant(forcedPromotionId) != null || promotionFetched,
  /**
   * Every BTS slide sells the MS in AI, so the evergreen Master's card is dropped from all three
   * carousels while the sale runs. `back-to-school-2026-msai-suppression.spec.ts` asserts these
   * keys still match the entries in each surface's source list.
   */
  replacesEvergreenKeys: {
    catalog: ['masters-artificial-intelligence'],
    experience: ['masters_ai'],
    homepage: ['masters-artificial-intelligence'],
  },
  resolve: ({ forcedPromotionId, promotionId }) => resolveBts2026SaleVariant(forcedPromotionId, promotionId),
};
